export function ChannelMenuPartComponent() {
  return null;
}
